<template>
  <div id="privilege-information-exchange" class="form-custom">
    <b-row class="mobile-topup-form">
        <b-col cols="12">
          <b-card no-body class="mb-1 pb-2">
            <b-card-header>
              <span class="information-header">Transfer Point</span>
            </b-card-header>
            <b-row class="px-5">
              <b-col cols="12">
                <b-row>
                  <b-col cols="12">
                    <b-form-group
                      :label="'Carriers'"
                      label-for="carriers"
                      label-class="font-medium-5"
                    >
                      <div class="d-flex flex-wrap">
                        <div
                          v-for="carrier in carriersList.payload"
                          :key="carrier.schemeid + '-carrier'"
                          class="exchange-carrier-wrp"
                          :class="[
                            formData.ExchangeId == carrier.schemeid &&
                              `active`,
                            isEdit && 'disabled',
                          ]"
                          @click="$emit('onSelectCarrierExchange',carrier)"
                        >
                          <img
                            :src="IconAis"
                            class="exchange-carrier-image m-auto"
                            alt=""
                            draggable="false"
                          />
                        </div>
                      </div>
                    </b-form-group>
                  </b-col>
                </b-row>
              </b-col>
            </b-row>
          </b-card>
        </b-col>
    </b-row>
  </div>
</template>

<script>
import { computed, reactive, ref, watch,onBeforeMount,getCurrentInstance } from "@vue/composition-api";
import { privilegeInfoModel } from "@/models/privilege/privilege-form";
import useValidationModal from "@/@core/components/base-modal/hooks/useValidationModal";
import router from "@/router";
import store from "@/store";
import IconAis from "@/assets/images/pages/privilege/topup/ais.png";

export default {
  components: {
    IconAis
  },
  props: { 
    isEdit: { type: Boolean, default: false },
    formData: { type: Object, default: {} }
  },
  setup(props) {
    const vm =getCurrentInstance().proxy;
    const {
      openErrorModal,
      openSuccessModal,
      openWarningModal,
      openDefaultErrorModal,
    } = useValidationModal();

    const {
      fetchExchangeCarriers
    } = privilegeInfoModel();

    const carrierSelect = reactive({
      id: 0,
      stepValue: 0,
      minValue: 0,
    });

    const carriersList = reactive({
      payload: [],
    });


    const fetchCarriersList = () => {
      window.$loading(true);
      store
        .dispatch("api/apiRequest", fetchExchangeCarriers)
        .then((response) => {
          if(response.data.carriers){
            carriersList.payload = response.data.carriers.schemes;
            if(props.isEdit){
              let carrier = carriersList.payload.find((o) => {
                return o.schemeid == props.formData.ExchangeId;
              });
              if(carrier) {
                vm.$emit('onSetSpinValueExchange',carrier)
              }
            
            }
          }  
        })
        .catch((err) => {
          openDefaultErrorModal(err);
        })
        .finally(() => {
          window.$loading(false);
        });
    };


    onBeforeMount(() => {
      fetchCarriersList();
    });

    return {
      IconAis,
      carrierSelect,
      carriersList,
    };
  }
}
</script>

<style>

</style>